import { Injectable } from '@angular/core';
import cloneDeep from 'lodash.clonedeep';
import { DateHelper } from '../utils/DateHelper';

@Injectable({
  providedIn: 'root',
})
export class HelperService {
  public uniq(array: any[]): any[] {
    let result = [...new Set(array)];
    return result;
  }

  public groupBy(arr: any[], criteria: any): object {
    return arr.reduce(function (obj, item) {
      let key = typeof criteria === 'function' ? criteria(item) : item[criteria];

      if (!Object.prototype.hasOwnProperty.call(obj, key)) {
        obj[key] = [];
      }

      obj[key].push(item);

      return obj;
    }, {});
  }

  public cloneDeep(objToClone: any): any {
    if (objToClone == null || typeof objToClone !== 'object') return objToClone;

    if (objToClone instanceof Object) {
      return cloneDeep(objToClone);
    }
  }

  public cloneDeepArray(arrToClone: any[]): any[] {
    if (arrToClone == null || typeof arrToClone !== 'object') return arrToClone;

    if (arrToClone instanceof Array) {
      return cloneDeep(arrToClone);
    }
  }

  public isValidDate(date: DateHelper): boolean {
    return date instanceof DateHelper;
  }
}
